import {Record} from "immutable";
import {
    onInventoryLoad,
    onInventoryLoadSuccess,
    onInventoryLoadFail,
    onInventoryChangeStockStatus, onInventoryChangeStockStatusSuccess, onInventoryChangeStockStatusFail,
    onInventoryUpdateType, onInventoryUpdateTypeFail, onInventoryUpdateTypeSuccess, onInventoryUpdateStockLimit
} from "./actions";

const inventory = new Record({
    loading: false,
    loading_item_id: 0,
    inventory: [],
    categories: [],
    category: null,
    status: null,
    statuses: [],
})();

export default (state = inventory, action) => {
    switch (action.type) {
        case onInventoryLoad().type:
            return state.set('loading', true);

        case onInventoryLoadSuccess().type:
            return state.set('loading', false)
                .set('categories', action.data.categories)
                .set('category', action.data.category)
                .set('inventory', action.data.inventory)
                .set('statuses', action.data.statuses)
                .set('status', action.data.status);

        case onInventoryLoadFail().type:
            return state.set('loading', false);

        case onInventoryChangeStockStatus().type:
            return state.set('loading_item_id', action.item.id)
                .set('loading', true)
                .setIn(['inventory', action.categoryIndex, 'dishes', action.itemIndex, 'stock_status'], action.status);

        case onInventoryChangeStockStatusSuccess().type:
        case onInventoryChangeStockStatusFail().type:
            return state.set('loading', false)
                .set('loading_item_id', 0);

        case onInventoryUpdateType().type: {
            const status = state.getIn(['inventory', action.categoryIndex, 'dishes', action.itemIndex, action.orderType]);
            return state.set('loading_item_id', action.item.id)
                .set('loading', true)
                .setIn(['inventory', action.categoryIndex, 'dishes', action.itemIndex, action.orderType], !status);
        }
        case onInventoryUpdateTypeSuccess().type:
        case onInventoryUpdateTypeFail().type:
            return state.set('loading', false)
                .set('loading_item_id', 0);

        case onInventoryUpdateStockLimit().type:
            return state.set('loading', true);

        default:
            return state;
    }
}
